<template lang="pug">
  div.container-fluid.animated.fadeIn
    nav(aria-label="breadcrumb")
      b-breadcrumb
        b-breadcrumb-item
          router-link(to="/match")
            i.fa.fa-gamepad
            span.ml-1 {{ $t("ui.match") }}
        b-breadcrumb-item
          router-link(to="/match/rsrtcontrol")
            i.fas.fa-tasks
            span.ml-1 {{ $t("ui.rs_rt_control") }}
    div.row.mb-5
      div.col-md-12
        div.card
          div.card-header
            div.row.mb-1(style="width: 30%;")
              b-input-group(size="sm")
                b-input-group-text(slot="prepend")
                  span {{ $tc('ui.sports', 1) }}
                b-form-select(v-model="sportType")
                  option(v-for="sportInfo in sportOption" v-bind:value="sportInfo.value")
                    | {{ sportInfo.text }}
            div.row.mb-1(style="width: 30%;")
              b-input-group(size="sm")
                b-input-group-text(slot="prepend")
                  span {{ $tc("ui.providers", 1) }}
                b-form-select(v-model="providerType")
                  option(value="") {{ $t("ui.all") }}
                  option(value="sbo") {{ $t("ui.sbo") }}
                  option(value="ibc") {{ $t("ui.ibc") }}
          div.card-body.p-1
            .clusterize
              .clusterize-scroll
                table.tablex(style="width: auto;" v-columns-resizable).mb-5
                  thead
                    tr
                      th.sticky-position
                        span {{ $tc("ui.providers", 1) }}
                      th.sticky-position
                        span {{ $tc("ui.sports", 1) }}
                      th.text-center.sticky-position(width=100 style="z-index: 10;")
                        span {{ $t("ui.disabled") }}
                  tbody.clusterize-content
                    tr(v-for="(item, index) in filterRSRTControlList")
                      td
                        span.text-uppercase {{ item.provider_id }}
                      td
                        span.text-uppercase {{ item.sport_type }}
                      td.actions
                        div.d-flex.justify-content-center.align-items-center
                          label.switch.switch-label.switch-info.switch-sm.switch-xs.m-0
                            input.switch-input(type="checkbox" v-model="item.disabled_option" @change="changedDisable(item, $event)")
                            span.switch-slider(:data-checked='on' :data-unchecked='off')
</template>
<script>
import config from "@/config";
import errorTags from "@/errorTags";

export default {
  data() {
    return {
      loading: false,
      feedback: {
        success: false,
        status: errorTags.request.failed
      },
      onContentReady: function(e) {
        if (!collapsed) {
          e.component.expandRow(e.component.getKeyByRowIndex(0));
          collapsed = true;
        }
      },
      sportList: [],
      rsrtControlList: [],
      sportType: "",
      providerType: "",
    }
  },
  computed: {
    on() {
      return this.$t("ui.on");
    },
    off() {
      return this.$t("ui.off");
    },
    sportOption: function() {
      var list = [];

      list.push({
        text: "ALL SPORTS",
        value: ""
      });

      for (var i = 0; i < this.sportList.length; i++) {
        list.push({
          text: this.sportList[i].sport_type,
          value: this.sportList[i].sport_type
        });
      }

      return list;
    },
    filterRSRTControlList() {
      return this.rsrtControlList
        .filter(item => {
          if (this.sportType == "")
            return item.sport_type.indexOf(this.sportType) > -1;
          else
            return item.sport_type == this.sportType;
        })
        .filter(item => {
          return item.provider_id.indexOf(this.providerType) > -1;
        })
        .sort((a, b) => {
          return a.provider_id > b.provider_id ? 1 : -1;
        })
        .sort((a, b) => {
          return a.sport_type > b.sport_type ? 1 : -1;
        });
    }
  },
  mounted: function() {
    this.getSportList();
    this.getRSRTControlList();
  },
  methods: {
    getSportList() {
      let url = config.sportListUrl();

      var json = {
        action_by: this.$store.getters.username,
        session_token: this.$store.getters.sessionToken,
        page_id: config.accessRoles.rsrtcontrol
      };

      this.$http.post(url, json).then(
        function(response) {
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.sportList = response.data.tbl_sport_list;

              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    getRSRTControlList() {
      let url = config.rsrtControlListUrl();

      var json = {
        action_by: this.$store.getters.username,
        session_token: this.$store.getters.sessionToken,
        page_id: config.accessRoles.rsrtcontrol
      };

      this.$http.post(url, json).then(
        function(response) {
          // Success
          try {
            if (response) {
              if (typeof response.data.status == "string") {
                this.feedback.success = response.data.status == "1";
              } else {
                this.feedback.success = response.data.status == 1;
              }
              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.rsrtControlList = response.data.tbl_rsrt_control_list;
              } else {
                this.$helpers.handleFeedback(this.feedback.status);
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    changedDisable: function(item, eventStatus) {
      this.$helpers
        .alert({
          title: this.$t("ui.disabled"),
          text: this.$t("message.update_rsrt_control_confirm", { sport: item.sport_type, provider: item.provider_id }),
          type: "question",
          showCancelButton: true
        })
        .then(result => {
          if (result.value) {
            this.confirmDisable(item, eventStatus.srcElement.checked);
          } else {
            eventStatus.srcElement.checked = !item.disabled_option;
            item.disabled_option = !item.disabled_option;
          }
        });
    },
    confirmDisable: function(item, status) {
      let url = config.updateRSRTControlUrl();

      var json = {
        action_by: this.$store.getters.username,
        session_token: this.$store.getters.sessionToken,
        page_id: config.accessRoles.rsrtcontrol,
        sport_id: item.sport_id,
        provider_id: item.provider_id,
        disabled_option: status
      };

      this.feedback.success = true;
      // this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          // this.loading = false;
          // Success
          try {
            if (response) {
              if (typeof response.data.status == "string") {
                this.feedback.success = response.data.status == "1";
              } else {
                this.feedback.success = response.data.status == 1;
              }
              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.getRSRTControlList();
                this.$helpers.showDialog(this.$t("ui.disabled"), this.$t("message.success"), "success");
              } else {
                this.$helpers.handleFeedback(this.feedback.status);
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
        }
      );
    },
  }
}
</script>